import Timeline from '../../components/Timeline';
import Component from '../../components/Component';
import Loading from '../../components/Loading';
import { fillMissingDates } from '../../helpers/fillEmptyDates';

import query from './query';
import { keys } from './keys';
import { withTranslation } from 'react-i18next';

class Summary extends Component {
    constructor() {
        super();
        this.query = query;
    }

    render() {
        const { t } = this.props;

        if (this.state.loading) {
            return <Loading />;
        }
        return (
            <Timeline
                data={fillMissingDates(this.state.data)}
                error={this.state.error}
                header={t('discover.overview.shelflife.header')}
                content_id={this.props.content_id}
                direct_parent_id={this.props.direct_parent_id}
                parent_id={this.props.parent_id}
                forceRun={this.forceRun}
                keys={keys(t)}
            />
        );
    }
}

export default withTranslation()(Summary);
